import { useState, useCallback } from 'react';
import { api } from '../api';
export function useSearch() {
    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const search = useCallback((params) => {
        setLoading(true);
        setError(null);
        return api.search(params)
            .then(r => { setResult(r); return r; })
            .catch(err => { setError(err.message); throw err; })
            .finally(() => setLoading(false));
    }, []);
    return { result, loading, error, search };
}
